var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          staticClass: "py-0 d-flex flex-column justify-center align-center",
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "p",
            {
              staticClass: "h4 mt-4"
            },
            [_vm._v("Starting something Amazing")]
          ),
          _c("v-progress-circular", {
            attrs: {
              indeterminate: "",
              size: "64",
              width: "6",
              color: "primary"
            }
          }),
          _c(
            "p",
            {
              staticClass: "pt-4 h4"
            },
            [_vm._v("This will only take a moment!")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }